module.exports = __webpack_public_path__ + "media/src/assets/boatowner_small-03c0322f94b8810f7bbe774ddc3a8dac.png";